import { useNavigate } from 'react-router-dom'
import { routes } from '../../config'

export const useMoveMenuPage = () => {
  const nav = useNavigate()

  return () => nav(routes.menu)
}

export const useMoveClinetsPage = () => {
  const nav = useNavigate()

  return () => nav(routes.client)
}
export const useMoveDevicesZyuutenPage = () => {
  const nav = useNavigate()

  return () => nav(routes.deviceZyuuten)
}
export const useMoveDevicesRoadcellPage = () => {
  const nav = useNavigate()

  return () => nav(routes.deviceRoadcell)
}
export const useMoveDevicesRoadcellZentyouPage = () => {
  const nav = useNavigate()

  return () => nav(routes.deviceRoadcellZentyou)
}

export const useMoveDevicesYuatsuPage = () => {
  const nav = useNavigate()

  return () => nav(routes.deviceYuatsu)
}
export const useMoveDevicesZentyouPage = () => {
  const nav = useNavigate()

  return () => nav(routes.deviceZentyou)
}
